import React from 'react';
import { PropTypes } from 'prop-types';

export const getSingleCheckboxState = name => value => document
  .querySelector(`input[type="checkbox"][name="${ name }"]`)
  .checked;

export const getCheckboxValue = name => value => Array
  .from(document.querySelectorAll(`input[type="checkbox"][name="${ name }"]`))
  .filter(el => el.checked)
  .map(el => el != null && el.value);

const isCheckboxChecked = (
  modelValue,
  inputValue
) => (
  (modelValue
    && modelValue.length
    && typeof modelValue !== 'string'
    && modelValue.indexOf(inputValue) !== -1)
  || (modelValue
    && modelValue.length
    && typeof modelValue === 'string' && modelValue === inputValue)
  || (modelValue === true
    && inputValue === 'true')
  || (modelValue === false
    && inputValue === 'false')
);

// eslint-disable-next-line import/prefer-default-export
export const CheckboxInput = ({
  input,
  meta: {
    touched,
    error
  },
  item,
  iValue,
  className }) => (
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label className="form-checkbox">
      <input
        type="checkbox"
        { ...input }
        value={ iValue }
        checked={ isCheckboxChecked(input.value, iValue) }
      />
      <i className={ `form-icon ${ className } ${ touched && error && 'is-error' }` } />
      { item }
    </label>
);

CheckboxInput.propTypes = {
  input: PropTypes.shape().isRequired,
  item: PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  iValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  meta: PropTypes.shape().isRequired,
  className: PropTypes.string
};

CheckboxInput.defaultProps = {
  item: null,
  className: null
};
